export enum ValidationMethod {
  MinLength = -1,
  MaxLength = -2,
  UpperCase = -3,
  LowerCase = -4,
  SpecialChar = -5,
  Number = -6
}